var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewStar = function SvgReviewStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 12.75 3.998 2.414a.833.833 0 0 0 1.241-.902l-1.063-4.548 3.536-3.06c.556-.482.258-1.396-.478-1.46l-4.647-.392L8.767.51a.832.832 0 0 0-1.534 0l-1.82 4.293-4.647.393c-.736.063-1.034.977-.478 1.459l3.536 3.06-1.063 4.548a.833.833 0 0 0 1.241.902z"
  })));
};
export { SvgReviewStar as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvcmV2aWV3LXN0YXIuZTliMTgxNmYuc3ZnIjs=";